// pages/PrivacyPolicy.js
import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  const [hasAccepted, setHasAccepted] = useState(true);

  useEffect(() => {
    const consent = localStorage.getItem('privacyConsent');
    if (consent !== 'accepted') {
      setHasAccepted(false);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('privacyConsent', 'accepted');
    localStorage.setItem('consentDate', new Date().toISOString());
    setHasAccepted(true);
    window.location.reload();
  };

  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>

      <section>
        <h2>Data We Collect</h2>
        <ul>
          <li>User preferences and book ratings</li>
          <li>Favorite books and reading lists</li>
          <li>Usage patterns and app interactions</li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Data</h2>
        <p>We use your data to personalize your experience, save your preferences, and improve our service.</p>
      </section>

      <section>
        <h2>Data Storage</h2>
        <p>Your data is stored locally in your browser and on our secure servers. We do not sell your personal information.</p>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>You can request access to, modification of, or deletion of your personal data at any time.</p>
      </section>

      {!hasAccepted && (
        <div className="accept-container">
          <p>To use all features, you must accept our privacy policy.</p>
          <button onClick={handleAccept} className="accept-policy-btn">
            Accept Privacy Policy
          </button>
        </div>
      )}
    </div>
  );
}

export default PrivacyPolicy;
